import {
  REQUEST_WAS_CONFS,
  RESPONSE_WAS_CONFS,
  UPDATE_WAS_CONF_RESULTS,
  FAILURE_WAS_CONFS
} from "../../../actions/types";

const initialState = {
  keyword: "",
  isFetching: false,
  statusCode: 0,
  results: {},
  error: false,
  isAdmin: false,
  isInitalScreen: true,
  size: 10,
  from: 0,
  activePage: 1,
  total:0,
  sort: {
    label: "CONFERENCES",
    value: "name"
  },
  keywords: []
};


const setFetching = (state, action) => {
  return {
    ...state,
    isFetching: true,
    isAdmin: false,
    statusCode: 0,
    results: {},
    keyword: action.payload.keyword,
    isInitalScreen: false
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    results: {}
  };
};

const setResults = (state, action) => {
  let results = action.payload.results || [];
  let isAdmin = action.payload.isAdmin;
  let activePage = action.payload.activePage;
  let keywords = action.payload.keywords || [];
  let total = action.payload.total;
  let sort = action.payload.sort || {
    label: "NAME",
    value: "name"
  }
  let resultsTree = {};
  results.forEach(l => {
    resultsTree[l.id] = l;
  });

  return {
    ...state,
    isFetching: false,
    error: false,
    results: resultsTree,
    isAdmin: isAdmin,
    activePage: activePage,
    total: total,
    sort: sort,
    keywords
  };
};

const updateResults = (state, action) => {
  let updateInfo = action.payload.updateInfo;
  let remove = action.payload.remove;

  if (remove === true) {
    let newResults = {
      ...state.results
    };
    delete newResults[updateInfo.id];

    return {
      ...state,
      results: newResults
    };
  } else {
    let newResults = {
      ...state.results,
      [updateInfo.id]: updateInfo
    };

    return {
      ...state,
      results: newResults
    };
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_WAS_CONFS:
      return setFetching(state, action);
      break;

    case RESPONSE_WAS_CONFS:
      return setResults(state, action);

    case FAILURE_WAS_CONFS:
      return setFailure(state, action);

    case UPDATE_WAS_CONF_RESULTS:
      return updateResults(state, action);

    default:
      return state;
      break;
  }
};
